import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Observable } from 'rxjs';
import { AppConfigUtils } from '../utils';

export const EXCLUDE_LANGUAGE_INTERCEPTOR_HEADER = 'EXCLUDE_LANGUAGE_INTERCEPTOR_HEADER';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  constructor(
    private appConfigUtils: AppConfigUtils,
    private translocoService: TranslocoService
  ) {}

  /**
   * Intercept http requests and add the X-Language header if the request is to an API URL
   *
   * @param {HttpRequest<any>} req
   * @param {HttpHandler} next
   * @returns {Observable<HttpEvent<any>>}
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.appConfigUtils.isApiUrlIn(req.url) && !req.headers.has(EXCLUDE_LANGUAGE_INTERCEPTOR_HEADER)) {
      const languageReq = req.clone({
        headers: req.headers.set('X-Language', this.translocoService.getActiveLang()),
      });
      return next.handle(languageReq);
    }
    return next.handle(req);
  }
}
